import { onUnmounted } from 'vue'
import { useRouter } from 'vue-router'

export function onBeforeNavigation(fn) {
  const router = useRouter()
  const remove = router.beforeEach(fn)
  onUnmounted(remove)
}
